import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { isEmptyObject } from 'jquery';
import ReactNotification, { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import Services from '../../services/service.js';
import { MODALACTION, RESPONSE } from '../../config/constants';
import ModalPreviewMobile from './ModalPreviewMobile.js';

const { CREATE, EDIT, DELETE } = MODALACTION;
const { SUCCESS, FAILED } = RESPONSE;

class FormSubmodule extends Component {
  constructor(props){
    super(props);
    this.state = {
      dataSubmodule: [],
      activeSubmodule: [],
      modalAdd: false,
      modalAddChild: false,
      modalAddItem: false,
      actionModal: '',
      subModuleName: '',
      subModuleActive: '',
      yItemName: '',
      yItemAmbangAtas: '',
      yItemAmbangBawah: '',
      xItemName: '',
      xItemType: '',
      xItemAmbang: '',
      xItemAmbangAtas: '',
      xItemAmbangBawah: '',
      selectedItem: {},
      confirmationModal: false,
      confirmationFunc: null,
      timeType: false,
      showModalPreview: false,
    }

    this.stateParams = window.history.state.state;
    this.toggleModalPreview = this.toggleModalPreview.bind(this);
  }

  componentDidMount(){
    this.getDataSubmodule();
  }

  addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
		store.addNotification({
			title: notificationTitle,
			message: notificationMessage,
			type: notificationType,
			insert: "top",
			container: notificationPosition,
			animationIn: ["animated", "fadeIn"],
			animationOut: ["animated", "fadeOut"],
			dismiss: { duration: 2000 },
			dismissable: { click: true }
		});
	}

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.addNotification('success', 'Success', 'All your data has been successfully updated', 'top-right');
        break;
      case FAILED:
        this.addNotification('danger', 'Danger', 'Oops something went wrong !', 'top-right');
        break;
      default:
        break;

    }
  };

  getDataSubmodule = () => {
    const { selectedItem: { aliasName = '' }} = this.stateParams;
    Services.getSubModule(aliasName)
      .then(res => {
        this.setState({
          dataSubmodule: res
        });
        if(res.subModule.length > 0 && isEmptyObject(this.state.activeSubmodule)){
          this.setState({
            activeSubmodule: res.subModule[0]
          });
        } else if(res.subModule.length > 0 && !isEmptyObject(this.state.activeSubmodule)) {
          const updatedModule = res.subModule.filter(item => item._id === this.state.activeSubmodule._id);
          this.setState({
            activeSubmodule: updatedModule[0]
          });
        }
      })
      .catch(err => console.log(err));
  }

  handleFieldChange = (key) => (e) => {
    if(key === 'xItemType') {
      const timeLabel = e.target.selectedOptions[0].text;
      if(timeLabel === 'Time') {
        const state = { [key]: e.target.value, timeType: true };
        this.setState(state);
      } else {
        const state = { [key]: e.target.value, timeType: false };
        this.setState(state);
      }
    }
    else {
      const state = { [key]: e.target.value };
      this.setState(state);
    }
  }

  dataParser = (item = {}, index) => {
    if(isEmptyObject(item)) return null;
    const { name = '', type = '', _id = '', thresholdMax = '', thresholdMin = '' } = item;
    let idx = index + 1;
    let number1 = 1;
    let data = [{no: `${idx}`, name, type, parent: true, parentId: _id, thresholdMax, thresholdMin}];
    if(item.sub.length > 0){
      item.sub.forEach(el1 => {
        let number2 = 1;
        const { name, type, _id } = el1;
        data.push({no: `${idx}.${number1}`, name, type, parent: true, parentId: _id, thresholdMax, thresholdMin});
        if(el1.sub.length > 0) {
          el1.sub.forEach(el2 => {
            const { name, type, _id } = el2;
            data.push({ no: `${idx}.${number1}.${number2}`, name, type, parent: false, parentId: _id, thresholdMax, thresholdMin});
            number2++;
          });
        }
        number1++;
      });
    };

    return data;
  };

  handleSubmitModule = () => {
    const { dataSubmodule, subModuleName, subModuleActive, yItemName } = this.state;
    const aliasName = dataSubmodule.aliasName;

    const payload = {
      name: subModuleName,
      active: subModuleActive,
      yItem: {
        name: yItemName
      }
    };

    const param = { params: { moduleAliasName: aliasName }};

    Services.postSubModule(payload, param)
      .then(res => {
        this.setState({ modalAdd: false });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAdd: false })
        this.toggleNotification(FAILED);
        console.log(err)});
  };

  handleSubmitCloneModule = () => {
    const { dataSubmodule, activeSubmodule } = this.state;
    const aliasName = dataSubmodule.aliasName;
    const param = { params: { 
      moduleAliasName: aliasName,
      subModuleId: activeSubmodule._id
    }};

    Services.postCloneSubModule(null, param)
      .then(res => {
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.toggleNotification(FAILED);
        console.log(err)});
  };

  handleUpdateModule = () => {
    const { dataSubmodule, subModuleName, subModuleActive, selectedItem } = this.state;
    const aliasName = dataSubmodule.aliasName;

    const payload = {
      name: subModuleName === '' ? selectedItem.name : subModuleName,
      active: subModuleActive === '' ? selectedItem.active : subModuleActive,
    };

    const param = { params: {
      moduleAliasName: aliasName,
      subModuleId: selectedItem._id
    }};

    Services.updateSubModule(payload, param)
      .then(res => {
        this.setState({ modalAdd: false });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAdd: false })
        this.toggleNotification(FAILED);
        console.log(err)});
  };

  handleDeleteModule = () => {
    const { dataSubmodule, selectedItem } = this.state;
    const aliasName = dataSubmodule.aliasName;

    const payload = {
      params: {
        moduleAliasName: aliasName ,
        subModuleId: selectedItem._id
      }
    };

    const param = { params: { moduleAliasName: aliasName }};

    Services.deleteSubModule(payload, param)
      .then(res => {
        this.setState({ modalAdd: false });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAdd: false })
        this.toggleNotification(FAILED);
        console.log(err)});
  };

  handleSubmitYItem = () => {
    const { yItemName, activeSubmodule, yItemAmbangAtas, yItemAmbangBawah, dataSubmodule: { aliasName } } = this.state;
    const subName = activeSubmodule.name;
    const payload = {
      name: yItemName,
      thresholdMin: yItemAmbangBawah,
      thresholdMax: yItemAmbangAtas
    };
    const param = {
      params: {
        moduleAliasName: aliasName,
        subModuleName: subName
      }
    };

    Services.postYItem(payload, param)
      .then(res => {
        this.setState({ modalAddItem: false, yItemName: '', yItemType: '' });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAddItem: false })
        this.toggleNotification(FAILED);
        console.log(err)});
  };

  handleUpdateYItem = () => {
    const { yItemName, activeSubmodule, yItemAmbangAtas, yItemAmbangBawah, dataSubmodule: { aliasName }, selectedItem } = this.state;
    const subName = activeSubmodule.name;
    const payload = {
      name: yItemName === '' ? selectedItem.name : yItemName,
      thresholdMin: yItemAmbangBawah === '' ? selectedItem.thresholdMin : yItemAmbangBawah,
      thresholdMax: yItemAmbangAtas === '' ? selectedItem.thresholdMax : yItemAmbangAtas
    };
    const param = {
      params: {
        moduleAliasName: aliasName,
        subModuleName: subName,
        yItemId: selectedItem._id
      }
    };

    Services.updateYItem(payload, param)
      .then(res => {
        this.setState({ modalAddItem: false, yItemName: '', ytemType: ''});
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAddItem: false });
        this.toggleNotification(FAILED);
        console.log(err)});
  }

  handleDeleteYItem = () => {
    const { selectedItem, activeSubmodule , dataSubmodule: { aliasName }} = this.state;
    const param = {
      params: {
        yItemId: selectedItem._id,
        subModuleId: activeSubmodule._id,
        moduleAliasName: aliasName
      }
    }

    Services.deleteYItem(param)
      .then(res => {
        this.setState({ modalAddItem: false });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAddItem: false });
        this.toggleNotification(FAILED);
        console.log(err)
      });
  }

  handleSubmitXItem = () => {
    const {
      xItemName,
      xItemType,
      activeSubmodule,
      dataSubmodule: { aliasName },
      selectedItem,
      xItemAmbangAtas,
      xItemAmbangBawah
    } = this.state;
    const subName = activeSubmodule.name;

    const param = {
      params: {
        moduleAliasName: aliasName,
        subModuleName: subName,
        parentId: selectedItem.parentId
      }
    };

    const payload = {
      name: xItemName,
      type: xItemType,
      thresholdMin: xItemAmbangBawah,
      thresholdMax: xItemAmbangAtas,
      value: []
    };

    Services.postXItem(payload, param)
      .then(res => {
        this.setState({ modalAddChild: false, xItemName: '', xItemType: '', timeType: false });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAddChild: false });
        this.toggleNotification(FAILED);
        console.log(err)});
  }

  handleUpdateXItem = () => {
    const {
      xItemName,
      xItemType,
      activeSubmodule,
      dataSubmodule: { aliasName },
      selectedItem,
      xItemAmbangAtas,
      xItemAmbangBawah
     } = this.state;
    const subName = activeSubmodule.name;

    const param = {
      params: {
        moduleAliasName: aliasName,
        subModuleName: subName,
        xItemId: selectedItem.parentId
      }
    };

    const payload = {
      name: xItemName === '' ? selectedItem.name : xItemName,
      type: xItemType === '' ? selectedItem.type : xItemType,
      thresholdMin: xItemAmbangBawah === '' ? selectedItem.thresholdMin : xItemAmbangBawah,
      thresholdMax: xItemAmbangAtas === '' ? selectedItem.thresholdMax : xItemAmbangAtas,
      value: []
    };

    Services.updateXItem(payload, param)
      .then(res => {
        this.setState({ modalAddChild: false, xItemName: '', xItemType: '' });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAddChild: false });
        this.toggleNotification(FAILED);
        console.log(err)});
  }

  handleDeleteXItem = () => {
    const {activeSubmodule, dataSubmodule: { aliasName }, selectedItem } = this.state;
    const subName = activeSubmodule.name;

    const param = {
      params: {
        moduleAliasName: aliasName,
        subModuleName: subName,
        xItemId: selectedItem.parentId
      }
    };

    Services.deleteXItem(param)
      .then(res => {
        this.setState({ modalAddChild: false });
        this.toggleNotification(SUCCESS);
        this.getDataSubmodule();
      })
      .catch(err => {
        this.setState({ modalAddChild: false });
        this.toggleNotification(FAILED);
        console.log(err)});
  }

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item"><Link to="/checklistmanagement/form-module">Form Module</Link></li>
        <li className="breadcrumb-item active">Form Sub Module</li>
      </ol>
      <h1 className="page-header">Form Sub Module </h1>
    </div>
  );

  renderSubmoduleTable = () => {
    const { dataSubmodule : { subModule = [] } } = this.state;
    let no = 0;
    const subModuleJSON = JSON.stringify(this.state.dataSubmodule);
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>
            <div className='d-flex justify-content-between'>
              <h5>SubModule List</h5>
              <span className="float-right">
                <button className="btn btn-sm btn-primary width-70 mr-1" onClick={() => this.toggleAddModal(CREATE)}>Add</button>
                <button className="btn btn-sm btn-warning mr-1" onClick={this.toggleModalPreview}>Preview Mobile</button>
                <Link
                  to={{
                    pathname: `/checklistmanagement/form-preview/`,
                  }}
                  target="_blank"
                >
                <button
                onClick={() => {
                  localStorage.removeItem('subModule');
                  localStorage.setItem('subModule', subModuleJSON);
                }}
                className="btn btn-sm btn-success">Preview Web</button>
                </Link>
              </span>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>SubModule Name</th>
                    <th>Active</th>
                    <th width="5%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  { subModule.map((item, index) => {
                    no++;
                    return (
                      <tr key={index}>
                        <td>{no}</td>
                        <td>{item.name}</td>
                        <td>{item.active ? "True" : "False"}</td>
                        <td className="with-btn text-nowrap">
                          <button
                            className="btn btn-sm btn-warning width-60 m-r-2"
                            onClick={() => {
                              this.toggleConfirmationModal(false);
                              this.setState({
                                activeSubmodule: item,
                                confirmationFunc: this.handleSubmitCloneModule
                              });
                          }}>
                            Clone
                          </button>
                          <button className="btn btn-sm btn-lime width-60 m-r-2" onClick={() => this.setState({ activeSubmodule: item }) }>Detail</button>
                          <button
                            className="btn btn-sm btn-primary width-60 m-r-2"
                            onClick={() => this.toggleAddModal(EDIT, item)}
                          >Edit</button>
                          <button
                            onClick={() => this.toggleAddModal(DELETE, item)}
                            className="btn btn-sm btn-danger width-60">Delete</button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  }

  renderSubTable = item => {
    return (
      <tr key={item.no}>
        <td>{item.no}</td>
        <td>{item.name}</td>
        <td>{this.getTypeName(item.type)}</td>
        <td className="with-btn text-nowrap">
          { item.parent && <button className="btn btn-sm btn-lime width-80 m-r-2" onClick={() => this.toggleAddModalChild(CREATE, item)}>Add Child</button> }
          <button
            className="btn btn-sm btn-primary width-60 m-r-2"
            onClick={() => this.toggleAddModalChild(EDIT, item)}
          >Edit</button>
          <button
            className="btn btn-sm btn-danger width-60"
            onClick={() => this.toggleAddModalChild(DELETE, item)}
          >Delete</button>
        </td>
      </tr>

    )
  }

  renderYItemTable = () => {
    const { activeSubmodule } = this.state;

    if (activeSubmodule === undefined || activeSubmodule.yItem === undefined || activeSubmodule.yItem.items === undefined) return null;
    const title = activeSubmodule.name;
    const items = isEmptyObject(activeSubmodule.yItem) ? [] : [ ...activeSubmodule.yItem.items ];
    let no = 0;

    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>Y Item List {title}</h5>
              <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddModalItem(CREATE)}>Add</button>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Name</th>
                    <th width="1%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  { items.map((item, index) => {
                    no++;
                    return (
                      <tr key={index}>
                        <td>{no}</td>
                        <td>{item.name}</td>
                        <td className="with-btn text-nowrap">
                          <button
                            className="btn btn-sm btn-primary width-60 m-r-2"
                            onClick={() => this.toggleAddModalItem(EDIT, item)}
                          >Edit</button>
                          <button
                            onClick={() => this.toggleAddModalItem(DELETE, item)}
                            className="btn btn-sm btn-danger width-60">Delete</button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  }

  renderXItemTable = () => {
    const { activeSubmodule: { xItem = [], name = '' }  } = this.state;
    const title = name;
    return (
      <div className="col-xl-12">
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-xl-between">
              <h5>X Item List {title}</h5>
              <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddModalChild(CREATE)}>Add</button>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Checklist</th>
                    <th>Type</th>
                    <th width="1%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    xItem.map((item, index) => {
                      const dataSub = this.dataParser(item, index);
                      return dataSub.map(val => this.renderSubTable(val));
                    })
                  }
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    )
  }

  getTypeName = value => {
    switch(value) {
      case "string" :
        return "Textbox"
      case "label" :
        return "Judul"
      case "radio" :
        return "Pilihan"
      case "checkbox" :
        return "Checklist"
      case "time" :
        return "Time"
      default :
        return ''
    }
  }

  //Start Modal Method

  toggleAddModal = (action = '', item = {}) => {
    this.setState({
      modalAdd: !this.state.modalAdd,
      actionModal: action,
      selectedItem: item,
      subModuleName: '',
      subModuleActive: '',
      timeType: false
    });
  }

  renderAddModal = () => {
    const { actionModal, selectedItem, subModuleName, subModuleActive } = this.state;
    const textHeader = this.setHeaderSubmoduleText(actionModal);
    const filled = isEmptyObject(selectedItem);

    return (
      <Modal isOpen={this.state.modalAdd} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>{textHeader}</ModalHeader>
        <form onSubmit={(e) => this.setActionButtonModule(e, actionModal)}>
        <ModalBody>
          <div className="form-group">
            <label>SubModule Name</label>
            <input
              onChange={this.handleFieldChange('subModuleName')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.name : subModuleName}
              disabled={actionModal === DELETE}
              required
            />
          </div>
          <div className="form-group">
            <label>Active</label>
            <select
              onChange={this.handleFieldChange('subModuleActive')}
              className="form-control"
              defaultValue={!filled ? selectedItem.active : subModuleActive}
              disabled={actionModal === DELETE}
              required
            >
              <option value="">Select Option</option>
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </div>
          {
            (actionModal === CREATE) && (<div className="form-group">
            <label>Y Item Name</label>
            <input
              onChange={this.handleFieldChange('yItemName')}
              type="text"
              className="form-control"
              required
            />
          </div>)
          }

        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Cancel</button>
          <button className="btn btn-primary" type="submit">{actionModal}</button>
        </ModalFooter>
        </form>
      </Modal>
    )
  }

  setHeaderSubmoduleText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add Submodule';
      case EDIT :
        return 'Edit Submodule';
      case DELETE :
        return 'Are you sure want to delete ?';
      default:
        return '';
    }
  }

  setActionButtonModule = (e, value) => {
    e.preventDefault();
    switch (value) {
      case CREATE :
        this.handleSubmitModule();
        break;
      case EDIT :
        this.handleUpdateModule();
        break;
      case DELETE :
        this.toggleConfirmationModal(false);
        this.setState({
          confirmationFunc: this.handleDeleteModule,
          modalAdd: false
        })
        break;
      default:
        break;
    }
  }

  toggleAddModalChild = (action = '', item = {}) => {
    this.setState({
      modalAddChild: !this.state.modalAddChild,
      actionModal: action,
      selectedItem: item,
      xItemName: '',
      xItemType: '',
      xItemAmbangAtas: '',
      xItemAmbangBawah: '',
      timeType: false
    });
  }

  renderAddModalChild = () => {
    const { actionModal, selectedItem, xItemName, xItemType, xItemAmbangAtas, xItemAmbangBawah, timeType } = this.state;
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);
    const isCreate = actionModal === CREATE;
    const formType = !xItemType && !isCreate ? selectedItem.type : xItemType;
    const isTextbox = formType === 'string';

    return (
      <Modal isOpen={this.state.modalAddChild} toggle={() => this.toggleAddModalChild()}>
        <ModalHeader toggle={() => this.toggleAddModalChild()}>{textHeader}</ModalHeader>
        <form onSubmit={(e) => this.setActionButtonXItem(e, actionModal)}>
        <ModalBody>
          <div className="form-group">
            <label>Checklist</label>
            {(!timeType) && (
              <input
                onChange={this.handleFieldChange('xItemName')}
                type="text"
                className="form-control"
                defaultValue={!filled && !isCreate ? selectedItem.name : xItemName}
                disabled={actionModal === DELETE}
                required
              />
            )}
            {(timeType) && (
              <input
                onChange={this.handleFieldChange('xItemName')}
                type="time"
                className="form-control"
                defaultValue={!filled && !isCreate ? selectedItem.name : xItemName}
                disabled={actionModal === DELETE}
                required
              />
            )}
          </div>
          <div className="form-group">
            <label>Type</label>
            <select
              onChange={this.handleFieldChange('xItemType')}
              defaultValue={!filled && !isCreate ? selectedItem.type : xItemType}
              className="form-control"
              required
            >
              <option value="">Select Option</option>
              <option value="string">Textbox</option>
              <option value="label">Judul</option>
              <option value="radio">Pilihan</option>
              <option value="checkbox">Checklist</option>
              <option value="string">Time</option>
            </select>
          </div>

          {(isTextbox) && (
          <div>
            <div className="form-group">
              <label>Ambang Minimum</label>
              <input
                onChange={this.handleFieldChange('xItemAmbangBawah')}
                type="number"
                className="form-control"
                disabled={actionModal === DELETE}
                defaultValue={!filled && !isCreate ? selectedItem.thresholdMin : xItemAmbangBawah}
              />
            </div>
            <div className="form-group">
              <label>Ambang Maksimum</label>
              <input
                onChange={this.handleFieldChange('xItemAmbangAtas')}
                type="number"
                className="form-control"
                disabled={actionModal === DELETE}
                defaultValue={!filled && !isCreate ? selectedItem.thresholdMax : xItemAmbangAtas}
              />
            </div>
          </div>
          )}
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModalChild()}>Cancel</button>
          <button className="btn btn-primary" type="submit">{actionModal}</button>
        </ModalFooter>
        </form>
      </Modal>
    )
  }

  setActionButtonXItem = (e, value) => {
    e.preventDefault();
    switch (value) {
      case CREATE :
        this.handleSubmitXItem();
        break;
      case EDIT :
        this.handleUpdateXItem();
        break;
      case DELETE :
        this.toggleConfirmationModal(false);
        this.setState({
          confirmationFunc: this.handleDeleteXItem,
          modalAddChild: false
        })
        break;
      default:
        break;
    }
  }

  toggleAddModalItem = (action = '', item = {}) => {
    this.setState({
      modalAddItem: !this.state.modalAddItem,
      actionModal: action,
      selectedItem: item,
      yItemName: ''
    });
  }

  renderAddModalItem = () => {
    const { actionModal, selectedItem, yItemName } = this.state;
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);

    return (
      <Modal isOpen={this.state.modalAddItem} toggle={() => this.toggleAddModalItem('')}>
        <ModalHeader toggle={() => this.toggleAddModalItem()}>{textHeader}</ModalHeader>
        <form onSubmit={(e) => this.setActionButtonYItem(e, actionModal)}>
        <ModalBody>
          <div className="form-group">
            <label>Name</label>
            <input
              onChange={this.handleFieldChange('yItemName')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.name : yItemName}
              disabled={actionModal === DELETE}
              required
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModalItem()}>Cancel</button>
          <button className="btn btn-primary" type="submit">{actionModal}</button>
        </ModalFooter>
        </form>
      </Modal>
    )
  }

  renderConfirmationModal = () => {
    const { confirmationModal } = this.state;

    return (
      <Modal isOpen={confirmationModal} toggle={() => this.toggleConfirmationModal(false)}>
        <ModalHeader toggle={() => this.toggleConfirmationModal(false)}>Confirmation</ModalHeader>
        <ModalBody>
          <div className="form-group">
          <p>Are you sure ?</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleConfirmationModal(false)}>Cancel</button>
          <button className="btn btn-primary" onClick={() => this.toggleConfirmationModal(true)}>Yes</button>
        </ModalFooter>
      </Modal>
    )
  }

  toggleConfirmationModal = (confirm) => {
    const { confirmationFunc } = this.state;
    this.setState({
      confirmationModal: !this.state.confirmationModal
    });

    if (confirm) confirmationFunc();

    return;
  }

  setHeaderItemText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add Checklist';
      case EDIT :
        return 'Edit Checklist';
      case DELETE :
        return 'Are you sure want to delete ?';
      default:
        return '';
    }
  }

  setActionButtonYItem = (e, value) => {
    e.preventDefault();
    switch (value) {
      case CREATE :
        this.handleSubmitYItem();
        break;
      case EDIT :
        this.handleUpdateYItem();
        break;
      case DELETE :
        this.toggleConfirmationModal(false);
        this.setState({
          confirmationFunc: this.handleDeleteYItem,
          modalAddItem: false
        });
        break;
      default:
        break;
    }
  }
  //End Modal Method

  toggleModalPreview = () => {
    this.setState({showModalPreview: !this.state.showModalPreview});
  }

  render(){
    const {showModalPreview} = this.state;

    return(
      <div>
        <ReactNotification />
        {this.renderBreadcrumb()}
        <div className="row">
          {this.renderSubmoduleTable()}
          {this.renderYItemTable()}
          {this.renderXItemTable()}
        </div>
        {this.renderAddModal()}
        {this.renderAddModalChild()}
        {this.renderAddModalItem()}
        {this.renderConfirmationModal()}
        {showModalPreview &&
          <ModalPreviewMobile
            isOpen={showModalPreview}
            toggle={this.toggleModalPreview}
            selectedModule={this.stateParams.selectedItem._id}
          />
        }
      </div>
    )
  }
};

export default FormSubmodule;
